import classNames from "classnames/bind";
import styles from "./Modal.module.css";
import { useContext, useRef, useState } from "react";
import CurrentRole from "./CurrentRole";
import { WaitConfirmContext } from "../../../../contexts";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import { actions } from "../../../../store";
import { useNavigate } from "react-router-dom";

const cx = classNames.bind(styles);


function ModalRole({ onClose }) {
    const { userData } = useContext(WaitConfirmContext)
    const [choseCurrentRole, setChoseCurrentRole] = useState(false);

    const [dataStore, dispatch] = useStoreContext()
    const modalRef = useRef(null);
    const navigate = useNavigate();

    const handleChoseCurrent = () => {
        setChoseCurrentRole(!choseCurrentRole)
    }

    const handleCreateNewRole = () => {
        dispatch(actions.setUserPendingAc(userData))
        navigate('/admin/role/add_role')
    }

    const handleClickBg = (e) => {
        if (e.target === modalRef.current) {
            onClose()
        }
    }
    return (
        <div className={cx('wrapper')} onClick={handleClickBg} ref={modalRef}>
            <div className={cx('content')}>
                <p className={cx('header')}>Thêm quyền cho người dùng</p>
                {choseCurrentRole ? (
                    <CurrentRole onBack={handleChoseCurrent} onClose={onClose}/>
                ) : (
                    <div className={cx('control')}>
                        <button className={cx('button-control')} onClick={handleChoseCurrent}>
                            Chọn một quyền đã có
                        </button>
                        <p>Hoặc</p>
                        <button className={cx('button-control')} onClick={handleCreateNewRole}>
                            Tạo một quyền mới cho người dùng
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ModalRole;